module.exports = __webpack_public_path__ + "static/media/how-it-works-3.62c424e4.svg";